import React from 'react';
import { Play, Zap } from 'lucide-react';

function VideoSection({ videos }) {
  if (!videos || videos.length === 0) return null;

  const getYouTubeEmbedUrl = (url) => {
    const videoId = url.split('v=')[1] || url.split('/').pop();
    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <section className="py-12 my-12 relative overflow-hidden" data-testid="video-section" style={{ background: 'linear-gradient(135deg, #1A1A2E 0%, #16213E 50%, #1A1A2E 100%)' }}>
      <div className="absolute top-0 left-0 right-0 h-1" style={{ background: 'linear-gradient(90deg, #FFB703 0%, #E63946 100%)' }}></div>
      <div className="max-w-[1600px] mx-auto px-6 relative">
        <div className="flex items-center gap-3 mb-8">
          <div className="p-3 rounded-full" style={{ background: 'linear-gradient(135deg, #E63946 0%, #FFB703 100%)' }}>
            <Play size={24} className="text-white" fill="white" />
          </div>
          <h2 className="text-3xl sm:text-4xl tracking-tight leading-none font-bold text-white">
            VIDEO REPORTS
          </h2>
          <span className="inline-flex items-center gap-1 bg-[#FFB703] text-[#1A1A2E] px-2 py-0.5 text-xs font-bold tracking-[0.2em] uppercase">
            <Zap size={12} />
            LIVE
          </span>
        </div>

        <div className="flex gap-6 overflow-x-auto pb-4" style={{ scrollbarWidth: 'thin', scrollbarColor: '#E63946 #525252' }}>
          {videos.map((video, idx) => (
            <div key={video.id} className="flex-shrink-0 w-[400px] group" data-testid={`video-${idx}`}>
              <div className="aspect-video mb-3 border-2 border-[#FFB703] group-hover:border-[#E63946] transition-colors">
                <iframe
                  src={getYouTubeEmbedUrl(video.youtube_url)}
                  title={video.title}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-[#FFB703] transition-colors">
                {video.title}
              </h3>
              <p className="text-sm text-[#A0A0B5]">
                {video.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default VideoSection;
